import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_j95bbpz4b7: FaireBrandEntity = {
  token: "b_j95bbpz4b7",
  type: "brand",
  name: "HEBS lab",
  avatarUrl:
    "https://cdn.faire.com/fastly/4e15fe66c6d93225a5b75caf80abe5b8b21d9647226c4cc07ae873918bfdd8bf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d41b2845d7207b6615abc40ffc91da318bf0ee4d373714463981f3cad07bd312.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4e15fe66c6d93225a5b75caf80abe5b8b21d9647226c4cc07ae873918bfdd8bf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d41b2845d7207b6615abc40ffc91da318bf0ee4d373714463981f3cad07bd312.png",
  location: "Sunny Isles Beach, FL, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "HEBS Lab is a premium herbal supplement brand focused on clean, high-potency liquid extracts inspired by traditional herbal medicine and modern wellness science.\n\nOur formulas are created using carefully selected botanicals and concentrated liquid extraction methods to deliver fast-absorbing and effective herbal support. We specialize in tinctures designed to support key areas of wellness including respiratory health, digestion, immune balance, and overall vitality.\n\nEach product is crafted in the United States using carefully controlled small-batch production to ensure consistent quality and potency, using high-quality ingredients and clean formulations without unnecessary fillers.\n\nHEBS Lab was created with a simple philosophy: natural wellness should be effective, transparent, and beautifully crafted. Our mission is to bring the power of traditional herbs into modern daily wellness routines.\n\nToday our products are used by customers seeking natural ways to support their health and by retailers looking for premium herbal wellness products with strong shelf appeal.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:05.409Z",
    importedBy: "entity-db-cli",
  },
};
